export const WIDGET_CONFIG_TYPES = {
  NOTE: 'NOTE',
  IFRAME: 'IFRAME',
  SECTION_HEADER: 'SECTION_HEADER',
  CRM_CARD: 'CRM_CARD'
};
export default WIDGET_CONFIG_TYPES;

// TODO: Move IFRAME and NOTE widgets to this pattern, and remove its dependency on the report config };

export const isNonReportWidgetReport = widgetReport => {
  var _widgetReport$nonRepo, _widgetReport$nonRepo2;
  return 'nonReportWidget' in widgetReport && ((_widgetReport$nonRepo = widgetReport.nonReportWidget) === null || _widgetReport$nonRepo === void 0 ? void 0 : _widgetReport$nonRepo.widgetType) !== undefined && ((_widgetReport$nonRepo2 = widgetReport.nonReportWidget) === null || _widgetReport$nonRepo2 === void 0 ? void 0 : _widgetReport$nonRepo2.widgetConfig) !== undefined;
};
export const isSectionHeaderWidgetReport = widgetReport => {
  return isNonReportWidgetReport(widgetReport) && widgetReport.nonReportWidget.widgetType === WIDGET_CONFIG_TYPES.SECTION_HEADER;
};
export const isCrmCardWidgetReport = widgetReport => {
  return isNonReportWidgetReport(widgetReport) && widgetReport.nonReportWidget.widgetType === WIDGET_CONFIG_TYPES.CRM_CARD;
};

// TODO: Lift dashboard widget specific config out of report config field and into the nonReportWidget field of the report object instead
/** from https://git.hubteam.com/HubSpot/Dashboard/blob/master/DashboardBase/src/main/java/com/hubspot/dashboard/v2/reports/configs/NoteConfigIF.java */
export const isNoteWidgetReport = widgetReport => {
  return 'config' in widgetReport && widgetReport.config.configType === WIDGET_CONFIG_TYPES.NOTE;
};
export const isIframeWidgetReport = widgetReport => {
  return 'config' in widgetReport && widgetReport.config.configType === WIDGET_CONFIG_TYPES.IFRAME;
};